<template>
  <div class="fixed-overlay" v-if="!isHidden">
    <div class="modal-window">
      <div class="pop-up-widget">
        <div class="pop-up-widget__top-text pop-up-widget__top-text__desktop" :style="topTextStyle">Эти МФО одобрят вам<br>займ<span> с вероятностью 91%</span>
        </div>
        <div class="pop-up-widget__top-text pop-up-widget__top-text__mobile" :style="topTextStyle">Эти МФО<br>одобрят вам
          займ<br><span>с вероятностью 91%</span></div>
        <div class="pop-up-widget__showcase-block" :class="style">
          <div class="pop-up-widget__showcase" v-for="item in popupOffers" :key="item.id" :style="cardStyle">
            <div class="pop-up-widget__logo"><img :src="item.logo"></div>
            <div class="pop-up-widget__grid">
              <div class="pop-up-widget__showcase-mini-block">
                <div class="pop-up-widget__showcase__title">Сумма</div>
                <div class="pop-up-widget__showcase__data">
                  до {{ item.extended_fields.amount_to }}
                  ₽
                </div>
              </div>
              <div class="pop-up-widget__showcase-no-mobile">
                <div class="pop-up-widget__showcase__title">Возраст</div>
                <div class="pop-up-widget__showcase__data">до {{ item.extended_fields.age_to }} лет</div>
              </div>
              <div class="pop-up-widget__showcase-no-mobile">
                <div class="pop-up-widget__showcase__title">срок (дней)</div>
                <div class="pop-up-widget__showcase__data">{{ item.extended_fields.duration_to}}</div>
              </div>
              <div class="pop-up-widget__showcase-mini-block rate">
                <div class="pop-up-widget__showcase__title">Ставка</div>
                <div class="pop-up-widget__showcase__data">{{ item.extended_fields.percent_from }} %</div>
              </div>
            </div>
            <div class="pop-up-widget__showcase__btn-block">
              <a :style="buttonStyle"
                 class="pop-up-widget__showcase__btn"
                 :href="linkWithSysSubs(item.urls, 'popup')"
                 target="_blank"
              >
                получить займ
              </a>
            </div>
          </div>
        </div>
        <div class="pop-up-widget__button-box"><a class="pop-up-widget__button" :style="btnNoThanksStyle"  v-on:click="isHidden = true">Спасибо, не надо</a>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pop-up-widget {
  font-family:var(--font) !important;
  &__button {
    font-family:var(--font) !important;
  }
  &__top-text {
    font-family:var(--font) !important;
    &__desktop {
      font-family:var(--font) !important;
    }
  }
}
.pop-up-widget__showcase {
  border-radius:var(--border_radius) !important;
  font-family:var(--font) !important;

    &__title {
      font-family:var(--font) !important;
    }
    &__data {
      font-family:var(--font) !important;
    }

  &__btn {
    border-radius:var(--border_radius);
    &:hover {
      background-color: var(--btn_color_hover) !important;
      color: var(--btn_text_color_hover) !important;
    }

    &:active {
      background-color: var(--btn_color_active) !important;
      color: var(--btn_text_color_active) !important;
    }

  }

}
</style>
<script>
import WidgetMarketSettingsClass from './../common/WidgetMarketSettingsClass.js';
import {mapActions, mapGetters, mapState} from "vuex";
import links from "@/common/links";

export default {
  name: 'PopUp',
  mixins: [links],
  props: {
    options: {default: null}
  },
  data() {
    return {
      info: null,
      font: 'Roboto',
      style: 'vertical',
      btn_color_primary: '#0090D1',
      btn_color_hover: '#0952BF',
      btn_color_active: '#FF951D',
      btn_text_color_primary: '#FFFFFF',
      btn_text_color_hover: '#FFFFFF',
      btn_text_color_active: '#FFFFFF',
      border_radius: '16',
      category: [14],
      isHidden: false
    };

  },

  methods: {
    ...mapActions([
      'loadOffers',
      'initLoadOffers'
    ]),
    onChange(event) {
      this.font = event.options.font ?? this.font;
      this.style = event.options.style ?? this.style;
      this.btn_color_primary = event.options.btn_color_primary ?? this.btn_color_primary;
      this.btn_color_hover = event.options.btn_color_hover ?? this.btn_color_hover;
      this.btn_color_active = event.options.btn_color_active ?? this.btn_color_active;
      this.btn_text_color_primary = event.options.btn_text_color_primary ?? this.btn_text_color_primary;
      this.btn_text_color_hover = event.options.btn_text_color_hover ?? this.btn_text_color_hover;
      this.btn_text_color_active = event.options.btn_text_color_active ?? this.btn_text_color_active;
      this.border_radius = event.options.border_radius ?? this.border_radius;

      if (this.category != event.options.category) {
        this.category = event.options.category ?? this.category;

        if (window.WidgetMarketSettings !== undefined) {
          window.WidgetMarketSettings.dispatchEvent(new Event('onBeforeLoadOffers'));
        }
        
        this.loadOffers({
          categoryIds: this.category,
          platformId: this.platformId
        });
      }

    },
  },
  watch: {
    offers() {
      if (window.WidgetMarketSettings !== undefined) {
        window.WidgetMarketSettings.dispatchEvent(new Event('onAfterLoadOffers'));
      }
    }
  },
  computed: {
    ...mapGetters([
      'popupOffers',
    ]),
    ...mapState([
      'platformId',
      'offers'
    ]),
    topTextStyle() {
      return {
        '--font': this.font,
      }
    },
    buttonStyle() {
      return {
        '--btn_color_hover': this.btn_color_hover,
        '--btn_color_active': this.btn_color_active,
        '--btn_text_color_hover': this.btn_text_color_hover,
        '--btn_text_color_active': this.btn_text_color_active,
        background: this.btn_color_primary,
        color: this.btn_text_color_primary,
        '--border_radius': this.border_radius + 'px',
        '--font': this.font,
      }
    },
    btnNoThanksStyle() {
      return {
        '--font': this.font,
      }
    },
    cardStyle() {
      return {
        '--font': this.font,
        '--border_radius': this.border_radius + 'px'
      }
    },
    baseUrl() {
      return process.env.VUE_APP_WIDGET_MARKET_URL;
    },
  },
  mounted() {
    if (this.options !== null) {
      this.font = this.options.font ?? 'Roboto';
      this.style = this.options.style ?? 'vertical';

      // guard with default
      if (!['vertical', 'horizontal'].includes(this.style)) {
        this.style = 'vertical';
      }

      this.btn_color_primary = this.options.btn_color_primary ?? this.btn_color_primary;
      this.btn_color_hover = this.options.btn_color_hover ?? this.btn_color_hover;
      this.btn_color_active = this.options.btn_color_active ?? this.btn_color_active;
      this.btn_text_color_primary = this.options.btn_text_color_primary ?? this.btn_text_color_primary;
      this.btn_text_color_hover = this.options.btn_text_color_hover ?? this.btn_text_color_hover;
      this.btn_text_color_active = this.options.btn_text_color_active ?? this.btn_text_color_active;
      this.border_radius = this.options.border_radius ?? this.border_radius;
      this.category = this.options.category ?? this.category;
    }

    // global runtime-sync object
    if (window.WidgetMarketSettings === undefined) {
      window.WidgetMarketSettings = new WidgetMarketSettingsClass();
    }
    window.WidgetMarketSettings.addEventListener('change', this.onChange);

    window.WidgetMarketSettings.dispatchEvent(new Event('onBeforeLoadOffers'));
    this.initLoadOffers(this.options);

  },
  unmounted() {
    if (window.WidgetMarketSettings !== undefined) {
      window.WidgetMarketSettings.removeEventListener('change', this.onChange);
    }
  }
}
</script>
